import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { classes } from './MenuState.st.css';
import { dataHooks } from 'root/dataHooks';

export const MenuState = ({ content, title, subtitle }: { content: string; title?: string; subtitle?: string }) => {
  return (
    <div className={classes.menuState} data-hook={dataHooks.menus.menuState.container}>
      {title && (
        <Text className={classes.title} data-hook={dataHooks.menus.menuState.title} tagName="h3">
          {title}
        </Text>
      )}
      {subtitle && (
        <Text className={classes.subtitle} data-hook={dataHooks.menus.menuState.subtitle} tagName="h4">
          {subtitle}
        </Text>
      )}
      <Text className={classes.content} data-hook={dataHooks.menus.menuState.content} tagName="h4">
        {content}
      </Text>
    </div>
  );
};
